import React, { memo, useState } from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {actions} from "../../models/stores/actions";
import { isMath, isNormalZhEnCss, getClientRect, delay } from '../../utils';
import * as TYPES from '../../models/types';

import styles from './styles.module.scss';
import bgImg from '../../assets/img/cases/bg.png';


// install Swiper modules
const Index = memo(() => {

  const dispatch = useDispatch();
  const { handleViwerEvent } = actions;

  const recReSizeReducer = useSelector(({recReSizeReducer}) => recReSizeReducer.value);
  const { home: { casesInfo, contacts }, lang } = useSelector(({localesReducer}) => localesReducer.i18n);
  const { scrolVal, scrolFidx } = useSelector(({scrollNumReducer}) => scrollNumReducer);
  const [ activeIndex, setActiveIndex ] = useState(0);

  // 样式判断
  const normal = () => {
    return isNormalZhEnCss(lang, 'English') ? styles.normalen : styles.normalcn;
  };

  const list = [
    {
      id: 101,
      key: 'one',
      leftList: [
        {
          id: 'IMG01101',
          num: 0,
          img: casesInfo.list[0].img,
        },
      ],
      rightList: [
        {
          id: 'IMG01102',
          num: 1,
          img: casesInfo.list[1].img,
        },
        {
          id: 'IMG01103',
          num: 2,
          img: casesInfo.list[2].img,
        },
      ],
    },
    {
      id: 102,
      key: 'two',
      leftList: [
        {
          id: 'IMG01201',
          num: 3,
          img: casesInfo.list[3].img,
        },
        {
          id: 'IMG02202',
          num: 4,
          img: casesInfo.list[4].img,
        },
        {
          id: 'IMG03203',
          num: 5,
          img: casesInfo.list[5].img,
        },
      ],
      rightList: [
        {
          id: 'IMG01204',
          num: 6,
          img: casesInfo.list[6].img,
        },
      ],
    },
    {
      id: 103,
      key: 'three',
      leftList: [
        {
          id: 'IMG0101',
          num: 7,
          img: casesInfo.list[7].img,
        },
      ],
      rightList: [
        {
          id: 'IMG01301',
          num: 8,
          img: casesInfo.list[8].img,
        },
        {
          id: 'IMG02302',
          num: 9,
          img: casesInfo.list[9].img,
        },
        {
          id: 'IMG03303',
          num: 10,
          img: casesInfo.list[10].img,
        },
      ],
    }
  ];

  const handleShowViwer = (params) => {
    dispatch(handleViwerEvent({visible: TYPES.VIWERSHOW, activeIndex: params.num}));
  }

  const markBox = () => {
     return (
       <div className='markBox'>
          <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="32" cy="32" r="31" stroke="white" strokeWidth="2"/>
            <path fillRule="evenodd" clipRule="evenodd" d="M36.292 25.2918C36.3849 25.1987 36.4953 25.1248 36.6168 25.0744C36.7382 25.024 36.8685 24.998 37 24.998C37.1316 24.998 37.2618 25.024 37.3833 25.0744C37.5048 25.1248 37.6151 25.1987 37.708 25.2918L43.708 31.2918C43.8011 31.3847 43.875 31.4951 43.9254 31.6166C43.9759 31.7381 44.0018 31.8683 44.0018 31.9998C44.0018 32.1314 43.9759 32.2616 43.9254 32.3831C43.875 32.5046 43.8011 32.6149 43.708 32.7078L37.708 38.7078C37.5202 38.8956 37.2656 39.0011 37 39.0011C36.7345 39.0011 36.4798 38.8956 36.292 38.7078C36.1042 38.5201 35.9988 38.2654 35.9988 37.9998C35.9988 37.7343 36.1042 37.4796 36.292 37.2918L41.586 31.9998L36.292 26.7078C36.1989 26.6149 36.125 26.5046 36.0746 26.3831C36.0242 26.2616 35.9982 26.1314 35.9982 25.9998C35.9982 25.8683 36.0242 25.7381 36.0746 25.6166C36.125 25.4951 36.1989 25.3847 36.292 25.2918Z" fill="white"/>
            <path fillRule="evenodd" clipRule="evenodd" d="M20 32C20 31.7348 20.1054 31.4804 20.2929 31.2929C20.4804 31.1054 20.7348 31 21 31L42 31C42.2652 31 42.5196 31.1054 42.7071 31.2929C42.8946 31.4804 43 31.7348 43 32C43 32.2652 42.8946 32.5196 42.7071 32.7071C42.5196 32.8946 42.2652 33 42 33H21C20.7348 33 20.4804 32.8946 20.2929 32.7071C20.1054 32.5196 20 32.2652 20 32Z" fill="white"/>
          </svg>
       </div>
     )
  }

  const matchListImgs = () => {
     return list.map(item => {
       switch (item.key) {
         case 'one':
            return (
              <ul className='imgsUl' key={item.key}>
                <li className='itemImg'>
                  {item.leftList.map(item => (
                    <div key={item.id} onClick={() => handleShowViwer(item)} className="itemRowTop" style={{marginBottom: 0}}>
                      <img src={item.img} alt='' />
                      {markBox()}
                    </div>
                  ))}
                </li>
                <li className='itemImg'>
                    <div className="itemRowBot">
                      {item.rightList.map(item => (
                        <div key={item.id} onClick={() => handleShowViwer(item)} className="itemCol">
                          <img src={item.img} alt='' />
                          {markBox()}
                        </div>
                      ))}
                    </div>
                </li>
              </ul>
            );
         case 'two':
            return (
              <ul className='imgsUl' key={item.key}>
                <li className='itemImg'>
                  <div className="itemRowTop">
                    <img src={item.leftList[0].img} onClick={() => handleShowViwer(item.leftList[0])} alt='' />
                    {markBox()}
                  </div>
                  <div className="itemRowBot">
                    <div className="itemCol" onClick={() => handleShowViwer(item.leftList[1])}>
                      <img src={item.leftList[1].img} alt='' />
                      {markBox()}
                    </div>
                    <div className="itemCol" onClick={() => handleShowViwer(item.leftList[2])}>
                      <img src={item.leftList[2].img} alt='' />
                      {markBox()}
                    </div>
                  </div>
                </li>
                <li className='itemImg'>
                    {item.rightList.map(item => (
                    <div key={item.id} onClick={() => handleShowViwer(item)} className="itemRowOne">
                      <img src={item.img} alt='' />
                      {markBox()}
                    </div>))}
                </li>
              </ul>
            );
         default:
            return (
              <ul className='imgsUl' key={item.key}>
                <li className='itemImg'>
                  {item.leftList.map(item => (
                    <div key={item.id} onClick={() => handleShowViwer(item)} className="itemRowOne">
                      <img src={item.img} alt='' />
                      {markBox()}
                    </div>
                  ))}
                </li>
                <li className='itemImg'>
                    <div className="itemRowTop" onClick={() => handleShowViwer(item.rightList[0])}>
                      <img src={item.rightList[0].img} alt='' />
                      {markBox()}
                    </div>
                    <div className="itemRowBot">
                      <div className="itemCol" onClick={() => handleShowViwer(item.rightList[1])}>
                        <img src={item.rightList[1].img} alt='' />
                        {markBox()}
                      </div>
                      <div className="itemCol" onClick={() => handleShowViwer(item.rightList[2])}>
                        <img src={item.rightList[2].img} alt='' />
                        {markBox()}
                      </div>
                    </div>
                </li>
              </ul>
            );
       }
     });
  }
  
  const otherTemp = (item) => {
    switch(item.id){
      case 1003:
        return (<a style={{cursor: 'pointer'}} href={`tel:${item.desc}`}>{item.desc}</a>);
      case 1004:
        return (<a style={{cursor: 'pointer'}} href={`mailto:${item.desc}?subject=Testing`}>{item.desc}</a>);
      default:
        return (<span>{item.desc}</span>);
    }
    
  }

  const handleJumpMap = () => {
    window.open(contacts.mapAddress, 'target');
  }

  return (
    <div className={normal()} style={{background: `url(${bgImg}) no-repeat 100% 100% / cover`}}>
      <div className='info'>
        <h4 className='title'>{casesInfo.title}</h4>
        <p className='subTitle'>{casesInfo.subTitle}</p>
        <p className='desc'>{casesInfo.desc}</p>
      </div>
      <div className='listImgs'>
        {matchListImgs()}
      </div>
      <div 
        className='contacts'
        name={'contact'} 
        id={'contact'}
      >
        <h4 className='title'>{contacts.title}</h4>
        <p className='subTitle'>{contacts.subTitle}</p>

        <div className='infoBox'>
          <ul className='infoList'>
              {contacts.list.map(item => {
                return (
                  <li key={item.id}>
                    <strong>{item.name}</strong>
                    {otherTemp(item)}
                  </li>
                )
              })}
          </ul>
          <div className='jumopMap' onClick={handleJumpMap}>
            <span>{contacts.mapName}</span>
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="16" cy="16" r="15" stroke="#FF6D34" strokeWidth="2"/>
              <path fillRule="evenodd" clipRule="evenodd" d="M18.146 12.6459C18.1925 12.5994 18.2477 12.5624 18.3084 12.5372C18.3692 12.512 18.4343 12.499 18.5 12.499C18.5658 12.499 18.6309 12.512 18.6917 12.5372C18.7524 12.5624 18.8076 12.5994 18.854 12.6459L21.854 15.6459C21.9006 15.6924 21.9375 15.7475 21.9628 15.8083C21.988 15.869 22.0009 15.9341 22.0009 15.9999C22.0009 16.0657 21.988 16.1308 21.9628 16.1916C21.9375 16.2523 21.9006 16.3075 21.854 16.3539L18.854 19.3539C18.7602 19.4478 18.6328 19.5005 18.5 19.5005C18.3673 19.5005 18.2399 19.4478 18.146 19.3539C18.0522 19.26 17.9994 19.1327 17.9994 18.9999C17.9994 18.8671 18.0522 18.7398 18.146 18.6459L20.793 15.9999L18.146 13.3539C18.0995 13.3075 18.0625 13.2523 18.0373 13.1916C18.0121 13.1308 17.9991 13.0657 17.9991 12.9999C17.9991 12.9341 18.0121 12.869 18.0373 12.8083C18.0625 12.7475 18.0995 12.6924 18.146 12.6459Z" fill="#FF6D34" stroke="#FF6D34" strokeWidth="0.5"/>
              <path fillRule="evenodd" clipRule="evenodd" d="M10 16C10 15.8674 10.0527 15.7402 10.1464 15.6464C10.2402 15.5527 10.3674 15.5 10.5 15.5L21 15.5C21.1326 15.5 21.2598 15.5527 21.3536 15.6464C21.4473 15.7402 21.5 15.8674 21.5 16C21.5 16.1326 21.4473 16.2598 21.3536 16.3536C21.2598 16.4473 21.1326 16.5 21 16.5H10.5C10.3674 16.5 10.2402 16.4473 10.1464 16.3536C10.0527 16.2598 10 16.1326 10 16Z" fill="#FF6D34" stroke="#FF6D34" strokeWidth="0.5"/>
            </svg>
          </div>
        </div>
      </div>
    </div>
  );
});
export default Index;
